module.exports = __webpack_public_path__ + "static/media/health-right.47641051.svg";